const styles = theme => ({
  root: {

  },
  paper: {

  },
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative'
  },
  iconWrapper: {
    display: 'flex',
    position: 'absolute',
    top: '15%',
    right: "-5px",
    zIndex: 1
  },
  input: {
    '&::-ms-reveal': {
      display: 'none',
    },
    '&::-ms-clear': {
      display: 'none',
    },
  }
})
export default styles;
